import useTenantName from '@lib/hooks/useTenantName';
import { Eyebrow } from '@servicetitan/design-system';
import classNames from 'classnames';

type TenantNameProps = {
  tenantNameOrId: string;
};

const TenantName = ({ tenantNameOrId }: TenantNameProps) => {
  const name = useTenantName(tenantNameOrId);

  return (
    <div className={classNames('d-f')}>
      <Eyebrow size='small'>{name}</Eyebrow>
    </div>
  );
};

export default TenantName;
